module.exports = __webpack_public_path__ + "img/Mail.3695b133.png";